import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const getTwoFactorImage = (accessToken: string) =>
    RESTClient.postObservable('v2/logins/enable-two-factor', {accessToken}).map(({qr, twoFactorSecretId}) => ({
        imageUrl: qr,
        secret: twoFactorSecretId,
    }));

export const activateTwoFactor = (accessToken: string, secret: string, code: string) =>
    RESTClient.postObservable('v2/logins/validate-two-factor', {
        accessToken,
        twoFactorSecretId: secret,
        code,
    });

export const disableTwoFactor = (accessToken: string, password: string) =>
    RESTClient.postAuthenticatedObservable('v2/logins/disable-two-factor', {
        accessToken,
        password,
    });
